import { Outlet, useLocation } from 'react-router-dom';
// @mui
import { Box, Container, Link, Stack, Typography } from '@mui/material';
// components
import Logo from '../../components/Logo';
//
import { PATH_PAGE } from '../../routes/paths';
import MainFooter from './MainFooter';
import MainHeader from './MainHeader';

// ----------------------------------------------------------------------

export default function MainLayout() {
  const { pathname } = useLocation();

  const isHome = pathname === PATH_PAGE;

  return (
    <Stack sx={{ minHeight: 1 }}>
      <MainHeader />

      <Outlet />

      <Box sx={{ flexGrow: 1 }} />

      {!isHome ? (
        <MainFooter />
      ) : (
        <Box
          sx={{
            py: 5,
            textAlign: 'center',
            position: 'relative',
            bgcolor: 'background.default',
          }}
        >
          <Container>
            <Logo sx={{ mb: 1, mx: 'auto' }} />

            <Typography variant="caption" component="p">
              © Tüm hakları saklıdır
              <br /> made by &nbsp;
              <Link href="https://etkinokuma.com/">etkinokuma.com</Link>
            </Typography>
          </Container>
        </Box>
      )}
    </Stack>
  );
}
